/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Explorer_Info_Lock_TextInputs */



/**
* | output |
* | --- |
* | "Do you want to lock \"{name}\"? This will prevent others from modifying it." |
*
* @param {Explorer_Info_Lock_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_lock_text = /** @type {((inputs: Explorer_Info_Lock_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Lock_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Voulez-vous verrouiller "${i?.name}" ? Cela empechera les autres de le modifier.`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Möchten Sie "${i?.name}" sperren? Dadurch wird verhindert, dass andere es verändern.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Vuoi bloccare "${i?.name}"? Questo impedirà ad altri di modificarlo.`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Вы хотите заблокировать "${i?.name}"? Это предотвратит его изменение другими пользователями.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`¿Quieres bloquear "${i?.name}"? Esto impedirá que otros lo modifiquen.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`是否要锁定“${i?.name}”？这将防止其他人对其进行修改。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`「${i?.name}」をロックしますか？ロックすると、他のユーザーが変更できなくなります。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`क्या आप "${i?.name}" को लॉक करना चाहते हैं? इससे दूसरों को इसे संशोधित करने से रोका जा सकेगा।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Deseja bloquear "${i?.name}"? Isso impedirá que outros o modifiquem.`)
	return /** @type {LocalizedString} */ (`Do you want to lock "${i?.name}"? This will prevent others from modifying it.`)
});